import React from 'react';

export const SentEmail = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4714 1.52827C14.7318 1.78862 14.7318 2.21073 14.4714 2.47108L7.13807 9.80441C6.87772 10.0648 6.45561 10.0648 6.19526 9.80441C5.93491 9.54406 5.93491 9.12195 6.19526 8.8616L13.5286 1.52827C13.7889 1.26792 14.2111 1.26792 14.4714 1.52827Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4716 1.52829C14.6544 1.71106 14.715 1.98301 14.6272 2.22612L10.2939 14.2261C10.2876 14.2435 10.2806 14.2606 10.2729 14.2774C10.1905 14.4573 10.0582 14.6097 9.89164 14.7166C9.72512 14.8235 9.53141 14.8803 9.33354 14.8803C9.13567 14.8803 8.94197 14.8235 8.77545 14.7166C8.61291 14.6123 8.48293 14.4646 8.40015 14.2903L6.16997 9.82993L1.70963 7.59976C1.53534 7.51698 1.38762 7.387 1.2833 7.22446C1.17644 7.05793 1.11963 6.86423 1.11963 6.66636C1.11963 6.46849 1.17644 6.27479 1.2833 6.10826C1.39017 5.94174 1.5426 5.8094 1.72248 5.72697C1.73928 5.71927 1.7564 5.71227 1.77378 5.70599L13.7738 1.37266C14.0169 1.28487 14.2888 1.34552 14.4716 1.52829ZM2.91472 6.71159L6.96502 8.73674C7.09404 8.80125 7.19865 8.90587 7.26316 9.03488L9.28831 13.0852L12.8908 3.10912L2.91472 6.71159Z"
      fill="currentColor"
    />
  </svg>
);
